import UserLocation from 'models/user/UserLocation';
import ViewerUserBiometrics from 'models/user/ViewerUserBiometrics';
import jQuery from 'jquery';
import { isChinaUser } from 'utils/ChinaUtil';
import BaiduGeolocationService from 'Map/utils/BaiduGeolocationService.js';

var LocationUtil = {
    // Use Geolocation API from Browser to identify lat and long
    // Browser will ask for permission
    // return lat long
    getGeoLocation: function(successCallback, errorCallback) {
        if (!successCallback) {
            throw 'successCallback is required';
        }

        if (!navigator.geolocation) {
            if (errorCallback) {
                errorCallback('Geolocation is not supported');
            }
            return;
        }

        function success(position) {
            successCallback({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                accuracy: position.coords.accuracy,
                altitude: position.coords.altitude,
                altitudeAccuracy: position.coords.altitudeAccuracy,
                heading: position.coords.heading,
                speed: position.coords.speed
            });
        }

        function error() {
            if (errorCallback) {
                errorCallback('Unable to retrieve location');
            }
            return;
        }

        if (isChinaUser()) {
            BaiduGeolocationService.getCurrentPosition((res) => {
                success({
                    coords: {
                        latitude: res.lat,
                        longitude: res.lng
                    }
                });
            }, error);
        } else {
            navigator.geolocation.getCurrentPosition(success, error);
        }
    },

    // return UserLocation model
    getUserLocation: function(successCallback, errorCallback) {
        if (!successCallback) {
            throw 'successCallback is required';
        }

        var userLocation = new UserLocation();
        userLocation.fetch({
            success: function(userLocation) {
                successCallback(userLocation.toJSON());
            },
            error: function(collection, response, options) {
                if (errorCallback) {
                    errorCallback(collection, response, options);
                }
            }
        });
    },

    isVietnamLocation: function() {
        let browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // There're only 2 possible browser timezone values in Vietnam
        return (
            browserTimezone && (browserTimezone.indexOf('Ho_Chi_Minh') >= 0 || browserTimezone.indexOf('Saigon') >= 0)
        );
    },

    shouldHideOSM: function() {
        if ((ViewerUserBiometrics && ViewerUserBiometrics.getCountryCode() === 'VN') || this.isVietnamLocation()) {
            return true;
        }
        return false;
    },

    isInternal: function(successCallback, errorCallback) {
        // user is external if cf-ray is available
        // making a request to common_en because it's cached by CF and it's tiny
        jQuery.ajax({
            url: '/modern/common/common_en.properties',
            type: 'GET',
            success: function(response, status, xhr) {
                if (xhr.getResponseHeader('cf-ray')) {
                    successCallback(false);
                } else {
                    successCallback(true);
                }
            },
            error: function(response) {
                if (errorCallback) {
                    errorCallback(response);
                }
            }
        });
    }
};

export default LocationUtil;
